import { render, staticRenderFns } from "./VDialog.vue?vue&type=template&id=06c6b9ab&scoped=true&"
import script from "./VDialog.vue?vue&type=script&lang=js&"
export * from "./VDialog.vue?vue&type=script&lang=js&"
import style0 from "./VDialog.vue?vue&type=style&index=0&id=06c6b9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6b9ab",
  null
  
)

export default component.exports